





















































import { Component, Mixins } from 'vue-property-decorator';
import moment from 'moment';
import filesaver from 'file-saver';

import MyList from '@/mixins/list';

import DetailList from './account-report-detail-list.vue';

@Component({
  components: {
    DetailList,
  },
})
export default class extends Mixins(MyList) {
  detailListModalVisible = false

  listParams = {}

  xlsname = '入金'

  report_id = 0

    month = ''

    type = ''

    dispatchType = 'bi/reportDetail'

    columns: any[] = [
      { title: '场馆名称', dataIndex: 'stadium_name' },
      { title: '订场订单', scopedSlots: { customRender: 'money1' } },
      { title: '场馆会员卡购买', scopedSlots: { customRender: 'money2' } },
      { title: 'AI会员卡购买', scopedSlots: { customRender: 'money3' } },
      { title: '绑线订单', scopedSlots: { customRender: 'money4' } },
      { title: '其他订单', scopedSlots: { customRender: 'money5' } },
      { title: '羽约余额充值', scopedSlots: { customRender: 'money6' } },
      { title: '微信商户入金（正式）', scopedSlots: { customRender: 'mp_prod_money' } },
      { title: '微信商户入金（测试）', scopedSlots: { customRender: 'mp_test_money' } },
      { title: '微信商户入金（开发）', scopedSlots: { customRender: 'mp_dev_money' } },
    ]

    showDetailListModal(params: any) {
      this.listParams = params;
      this.detailListModalVisible = true;
    }

    hideDetailListModal() {
      this.detailListModalVisible = false;
    }

    mounted() {
      const query = { ...this.$route.query };

      //   console.log(query.id);
      if (query.type) {
        this.type = String(query.type);

        if (this.type == '1') {
          // 出金
          this.xlsname = '出金';
          this.columns = [
            { title: '场馆名称', dataIndex: 'stadium_name' },
            { title: '取消订单', scopedSlots: { customRender: 'money1' } },
            { title: '退款', scopedSlots: { customRender: 'money2' } },
            { title: '球友提现', scopedSlots: { customRender: 'money4' } },
            { title: '场馆微信结算', scopedSlots: { customRender: 'money5' } },
            { title: '微信商户出金（正式）', scopedSlots: { customRender: 'mp_prod_money' } },
            { title: '微信商户出金（测试）', scopedSlots: { customRender: 'mp_test_money' } },
            { title: '微信商户出金（开发）', scopedSlots: { customRender: 'mp_dev_money' } },
          ];
        } else if (this.type == '2') {
          this.xlsname = '结算';
          this.columns = [
            { title: '场馆名称', dataIndex: 'stadium_name' },
            { title: '订场订单', scopedSlots: { customRender: 'money1' } },
            { title: '场馆会员卡购买', scopedSlots: { customRender: 'money2' } },
            { title: 'AI会员卡购买', scopedSlots: { customRender: 'money3' } },
            { title: '绑线订单', scopedSlots: { customRender: 'money4' } },
          ];
        } else if (this.type == '3') {
          this.xlsname = '押金';
          this.columns = [
            { title: '场馆名称', dataIndex: 'stadium_name' },
            { title: '押金入账日期', scopedSlots: { customRender: 'money1' } },
            { title: '押金金额', scopedSlots: { customRender: 'money5' } },
            { title: '押金退款金额', scopedSlots: { customRender: 'money4' } },
            { title: '押金退款日期', scopedSlots: { customRender: 'money3' } },
            { title: '业务员', scopedSlots: { customRender: 'money2' } },
          ];
        } else if (this.type == '4') {
          this.xlsname = '运维服务费';
          this.columns = [
            { title: '场馆名称', dataIndex: 'stadium_name' },
            { title: '运维费入账日期', scopedSlots: { customRender: 'money1' } },
            { title: '运维费金额', scopedSlots: { customRender: 'money5' } },
          ];
        } else if (this.type == '5') {
          this.xlsname = '购买';
          this.columns = [
            { title: '场馆名称', dataIndex: 'stadium_name' },
            { title: '购买入账日期', scopedSlots: { customRender: 'money1' } },
            { title: '购买金额', scopedSlots: { customRender: 'money5' } },
            { title: '退款日期', scopedSlots: { customRender: 'money3' } },
            { title: '退款金额', scopedSlots: { customRender: 'money4' } },
            { title: '业务员', scopedSlots: { customRender: 'money2' } },
          ];
        }
      }

      if (query.month) {
        this.month = String(query.month);
      }

      this.report_id = Number(query.id);

      this.loadData1({
        report_id: query.id,
      });
    }

    async loadData1(params: any) {
      this.loading = true;
      const res = await this.$store.dispatch(this.dispatchType, {
        ...params,
      });
      if (res && res.Data) {
        this.data = res.Data;
      }

      this.loading = false;
    }

    async exportExcel() {
      this.$confirm({
        title: '确认信息',
        content: '确认导出吗？',
        onOk: async () => {
          const res = await this.$store.dispatch('bi/reportDetailExport', {
            report_id: this.report_id,
            ...this.searchData,
          });
          // console.log(res)
          if (res && res.data) {
            const blob = new Blob([res.data], {
              type:
              'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
            });
            filesaver.saveAs(
              blob,
              `${this.xlsname}对账月报${this.month}-${moment().format('YYYY-MM-DD HH:mm:ss')}.xlsx`,
            );
          }
        },
      });
    }
}
